<!-- Main Page Start -->
<div class="content-wrapper table-full-bx">

  <!-- progress -->
   

     <!-- End -->
     <div class="page-content recruiterpanel">

         <div class="row">
             <div class="col-lg-12">
                 <div class="ibox ">  
                 <div class="ibox-body">
                   
                         <ol class="breadcrumb">
                             <li class="breadcrumb-item">  <a href="javascript:void(0);" (click)="backToJob()"> Jobs  </a> </li>
                             <li class="breadcrumb-item active"> Job Detail </li>
                         </ol>
                  
                         <div class="row">
                            <div class="col-sm-12 col-lg-10 col-md-10">
                                <div class="basicbk">
                                    <div class="innertext">
                                        <p class="para6">{{allData?.JobPost?.newId || "-"}}</p>
                                        <h6 class="heading-6">{{allData?.JobPost?.jobTitle || "-"}}</h6>
                                    </div>
                                    <div class="innertext">
                                        <p class="para6">Location</p>
                                        <h6 class="heading-6" *ngIf="allData?.JobPost?.workPlaceLocation != 'Remote'">
                                            {{allData?.JobPost?.location || "-"}}
                                        </h6>
                                        <h6 class="heading-6" *ngIf="allData?.JobPost?.workPlaceLocation == 'Remote'">
                                            -
                                        </h6>
                                    </div>
                                    <div class="innertext">
                                        <p class="para6">Post date</p>
                                        <h6 class="heading-6">{{allData?.JobPost?.createdAt | date: "d/M/YYYY"}}</h6>
                                    </div>
                                    <div class="innertext">
                                        <p class="para6">Schedule</p>
                                        <h6 class="heading-6">{{allData?.JobPost?.schedulesName || "-"}}</h6>
                                    </div>
                                    <div class="innertext">
                                        <p class="para6">User</p>
                                        <h6 class="heading-6">{{allData?.recruiter?.name || "-"}}</h6>
                                    </div>
                                </div>
                            </div>
                            <div class="col-sm-12 col-lg-2 col-md-2 ">
                                <div class="on-off">
                                    <div>
                                            <h6 class="heding-6">Position</h6>
                                            <p class="green" *ngIf="allData?.JobPost?.isBlocked==0">Open</p>
                                            <p class="green" *ngIf="allData?.JobPost?.isBlocked==1">Closed</p>
                                   </div>
                                    <label class="switch"  *ngIf="allData?.JobPost?.isBlocked==0">
                                        <input type="checkbox" [checked]="allData?.JobPost?.isBlocked==0" (change)="allData?.JobPost?.isBlocked==0">
                                        <span class="slider round" (click)="openModal(allData,jobStatus)"></span>
                                    </label>
                                    <label class="switch"  *ngIf="allData?.JobPost?.isBlocked==1"> 
                                        <span class="slider round" (click)="jobOpenStatus($event,allData?.JobPost?.id)"></span>
                                    </label>
                                </div>
                            </div>
                        </div>
                 <!-- Checkbox -->
      
                 <ul class="nav nav-pills job-list">
                    <li>
                        <a href="javascript:void(0)" (click)="redirectToApplicant()">Applicants</a>
                    </li>
                    <li class="active">
                        <a href="javascript:void(0)">Suggested Candidates</a>
                    </li>
                    <li>
                        <a href="javascript:void(0)" (click)="redirectToDetail()">Details</a>
                    </li>
           
                 </ul>
                 <!-- searchbox -->
                 <div class="flexbox align-item-baseline">


                  
                     <div class="iboxcontent">
                         <h3>Suggested Candidates</h3>
                         
                 </div>
                 <div class="input-group-icon input-group-icon-left ">

                     <div class="ibox-tools">
                    
                         <div class="col-list-right">
                            <form (ngSubmit)="searchFun()">
                                <div class="form-group">
                                    <span class="input-icon input-icon-right font-16"><img src="assets/images/search.svg"></span>
                                    <input type="text" [(ngModel)]="search" autocomplete="off" class="form-control form-control-rounded form-control-solid"
                                        name="search" id="key-search" placeholder="Search by Name,Location" />
                                    <span *ngIf="search" class="closeSearch" (click)="clearSearch()">&times;</span> 
                                </div>
                            </form>
                         </div>
                     </div>
           

                </div>
             </div>
                 <!-- end -->
                    <!-- Table -->
                     <div class="table-scroll table-wrapper table-responsive">
                         <table id="example" class="table table-bordered table-hover m-0 " style="width:100%">
                      
                                 <thead>
                                     <tr>
                                         <th class="width-auto ">Name </th>
                                         <th class="width-auto " >Location</th>   
                                         <th class="width-auto ">Action</th>
                                     </tr>
                                 </thead>  
                                    
                                 
                            

                             <tbody>
                                 <!-- 1 -->
                                 <tr  *ngFor="let data of listingData | paginate: { id:'pagination', itemsPerPage: pagination.limit, currentPage: currentPage ,totalItems: pagination.totalItems};let i=index">
                                     <td><a href="javascript:void(0);" class="jobid" (click)="redirectTo(data)">{{data.name}}</a></td>
                                     <td><a href="javascript:void(0);" (click)="redirectTo(data)">{{data.location}}</a></td>
                                     <td>
                                     <div class="action-wrap table-action">
                                         <a href="javascript:void(0)" (click)="shortListed($event,data.id)"><span><input type="radio" id="featured-2" name="featured">Shortlist</span></a>
                                         <a href="javascript:void(0)" (click)="hideListed($event,data.id)"><span><input type="radio" id="featured-2" name="featured">Hide</span></a> 
                                       </div>
                                     </td>
                                 </tr>
                          
                              
                             </tbody>
                         </table>
                  
                         <div class="noDataFound" *ngIf="listingData == 0">
                            <h2>No records found</h2>
                          </div>
                     </div>
                     <div class="col-sm-12 p-0" *ngIf="listingData.length > 0">
                        <ul class="pagination ">
                            <pagination-controls id="pagination" (pageChange)="pageChanged($event)" previousText="&#60;" nextText="Next" firstText="&#62;" lastText="Last"></pagination-controls> 
                        </ul>
                     </div>
             <!-- end -->
             </div>
         
             </div>
          </div>


         </div>

     </div>
</div>    

<!-- End -->
<ng-template #jobStatus>
    <div class="modal-body addModal text-left"> 
        <form [formGroup]="jobForm" (ngSubmit)="jobPostStatus()">
          <h4 class="uppercasetext p-0">Are you sure you want to close this position?</h4> 
          <div class="form-group">
            <label>Reason for closing job</label>
            <textarea class="form-control" placeholder="Please write here" formControlName="reason" maxlength="2000"></textarea>
            <p class="para5 text-left m-0">{{jobForm?.value?.reason?.length}}/2000</p>
            <div class="text-danger" *ngIf="jobForm.controls['reason'].hasError('required') && showError">
                *Please Enter reason.
            </div>
          </div>
          <div class="form-group"> 
            <div class="custom-control custom-checkbox">
                <input type="checkbox" class="custom-control-input" id="customCheckBox1" formControlName="isNotify" [value]="1" [checked]="jobForm.value.isNotify == 1" (change)="jobForm.value.isNotify = 1">
                <label class="custom-control-label" for="customCheckBox1">Do you want to notify users?</label>
            </div>
          </div>
          <div class="d-flex">

            <div class="form-group"> 
              <a href="javascript:void(0);" class="planbtn greyBtn" (click)="modalRef?.hide()">Cancel</a>
              </div> 
          <div class="form-group"> 
            <input type="submit" value="Close position"  class="planbtn fill">
          </div>
          
        </div>
        </form>
  </div>
  </ng-template> 
 